import { ELIA_CONCEPTS } from "./EliaLogos";

// Default concept — updatable via /brand/elia preview page.
export const DEFAULT_ELIA_CONCEPT = "lockup-horiz";

const KEY = "elia_selected_logo";

export function getSelectedElia() {
  if (typeof window === "undefined") return DEFAULT_ELIA_CONCEPT;
  return localStorage.getItem(KEY) || DEFAULT_ELIA_CONCEPT;
}

export function setSelectedElia(key) {
  if (typeof window === "undefined") return;
  localStorage.setItem(KEY, key);
  window.dispatchEvent(new Event("elia:logo:changed"));
}

export function findConcept(key) {
  return ELIA_CONCEPTS.find((c) => c.key === key) || ELIA_CONCEPTS[0];
}

/**
 * Universal ELIA brand component — reads the currently-selected concept
 * from localStorage and renders the matching SVG.
 */
export function EliaBrandLogo({ size = 40, color, accent }) {
  const c = findConcept(typeof window !== "undefined"
    ? (localStorage.getItem(KEY) || DEFAULT_ELIA_CONCEPT)
    : DEFAULT_ELIA_CONCEPT
  );
  const Comp = c.Component;
  return <Comp size={size} color={color} accent={accent} />;
}
